import React from "react";
import { Row, Col } from "react-bootstrap";
import userThumbnail from "../../../../../img/user-icon.svg";
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import "./style.scss";

const Index = () => {
  return (
    <div className="article-content-container">
      <div className="inner-article-content-container">
        <div className="details-content">
          <Row className="details-row">
            <Col className="info-col text-left">
              <div className="author-container">
                <span className="author-icon">
                  <img className="icon" src={userThumbnail} />
                </span>
                <span className="author-name">Erlend Bognøy</span>
              </div>
              <div className="published-container">
                <span className="author-published">9. April 2022</span>
              </div>
            </Col>
            <Col className="share-col text-right">
              <EmailShareButton
                subject="Leadfind Blogg: Slik brukte B&B Marketing Leadfind for å skaffe nye kunder og øke salget"
                body=""
              >
                <EmailIcon size={30} round={true} />
              </EmailShareButton>
              <FacebookShareButton>
                <FacebookIcon size={30} round={true} />
              </FacebookShareButton>
              <LinkedinShareButton>
                <LinkedinIcon size={30} round={true} />
              </LinkedinShareButton>
              <TwitterShareButton>
                <TwitterIcon size={30} round={true} />
              </TwitterShareButton>
            </Col>
          </Row>
        </div>
        <div className="article-content">
          <div className="paragraph">
            <p className="text">
              Vi i B&B Marketing var på utkikk etter et nytt salgsverktøy for å
              generere nye leads til våre markedsførings- og webdesign
              tjenester. Jeg hadde hørt om Leadfind fra en rekke
              bransjekollegaer og bestemte meg for å teste Leadfind ut. Helt fra
              dag èn så vi utrolig potensiale i Leadfind som et salgsverktøy,
              som vi kunne forme våre salgsaktiviteter rundt. Vi har aldri sett
              oss tilbake, da Leadfind dekker alle våre leadsgenereringsbehov,
              når det kommer til e-post markedsøring.
            </p>
          </div>
          <div className="paragraph">
            <p className="text">
              Vi har testet ut en hel rekke forskjellige salgsverktøy, men ingen
              av de har vært i nærheten av like enkel å bruke, godt utviklet og
              til en så god pris. Leadfind gir deg funksjoner, som man vanligvis
              må betale nærmere ti tusen kroner i måneden for, hvor man med
              Leadfind betaler 399,- er det utrolig verdi for pengene og vi
              gleder oss enormt til å bruke Leadfind videre!
            </p>
          </div>
          <div className="paragraph quote">
            <p className="text">
              Hvis du leter etter et salgsverktøy for å skape nye potensielle
              kunder, er Leadfind definitivt verdt å prøve ut. Leadfind lar deg
              lage e-postkampanjer og målrette deg mot potensielle kunder med
              laserpresisjon. Selv om det tar litt tid å sette opp, er
              avkastningen enorm. ROI-en vår fra bruk av Leadfind er helt
              utrolig! Leadfind er det salgsverktøyet som vi har best avkastning
              på.
            </p>
            <p className="signature">Erlend Bognøy, B&B Marketing AS</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
